import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

const HeaderWrapper = styled.div`
   display: flex;
   justify-content: space-between;
    ${mediaBreakpoint.down('md')} {
        width: 100%;
    }
    ${mediaBreakpoint.up('md')} {
        width: 50%;
    }
`;

export default HeaderWrapper;
